'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'box-taped';
var width = 448;
var height = 512;
var aliases = ["box-alt"];
var unicode = 'f49a';
var svgPathData = ['M32 160l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256-112 0 0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64-112 0zm7.3-32l108.6 0 22.9-80-57.9 0c-10.3 0-20 5-26 13.4L39.3 128zM277.2 48l22.9 80 108.6 0-47.6-66.6c-6-8.4-15.7-13.4-26-13.4l-57.9 0z', 'M416 416l0-256-112 0 0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64-112 0 0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32zM176 160l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64-96 0zm90.8-32l-22.9-80-39.9 0-22.9 80 85.6 0zm33.3 0l108.6 0-47.6-66.6c-6-8.4-15.7-13.4-26-13.4l-57.9 0 22.9 80zm-32-112l67 0c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.8 10.9 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.9 42.8C72.9 26 92.3 16 112.9 16l155.1 0zM170.8 48l-57.9 0c-10.3 0-20 5-26 13.4l-47.6 66.6 108.6 0 22.9-80z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxTaped = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;